import React from 'react';
import clsx from 'clsx';
import MuiAppBar from '@material-ui/core/AppBar';
import { APP_BAR } from 'ctsutheme/core';

const AppBar = ({ className, shaded, ...props }) => (
  <MuiAppBar
    className={clsx(APP_BAR.root, className, shaded && APP_BAR.shaded)}
    {...props}
  />
);

export default AppBar;
